var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfrastuctureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "infrastucture-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17403",
    "data-name": "Ret\\xE2ngulo 17403",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7458",
    "data-name": "Caminho 7458",
    d: "M10.333,6.333V4.667A1.672,1.672,0,0,0,8.667,3h-5A1.672,1.672,0,0,0,2,4.667V16.333A1.672,1.672,0,0,0,3.667,18H17a1.672,1.672,0,0,0,1.667-1.667V8A1.672,1.672,0,0,0,17,6.333Zm-1.667,10h-5V14.667h5Zm0-3.333h-5V11.333h5Zm0-3.333h-5V8h5Zm0-3.333h-5V4.667h5Zm8.333,10H10.333V8H17ZM15.333,9.667H12v1.667h3.333Zm0,3.333H12v1.667h3.333Z",
    transform: "translate(-0.333 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastuctureIcon);
export default __webpack_public_path__ + "static/media/infrastucture-icon.319af3cfdcda5ce57cfd7585339249cb.svg";
export { ForwardRef as ReactComponent };